<template lang="">
    <div>
        

      <div class="mb-3 pb-3 border border-l-0 border-r-0 border-t-0 border-b-1 border-[#D0D5DD]">
                                 <div class="flex justify-between items-center py-2">
                                    <h2 class="text-lg font-bold text-[#101828]">Chats </h2>
                                    <a href="one-to-one-chat" class="border border-[#D0D5DD] rounded-full p-1 w-[32px] h-[32px] flex items-center justify-center text-[#101828] hover:bg-[#0A0446] hover:text-white"><i class="ti ti-chevron-right"></i></a>
                                 </div>

                                 <div>
                                    <ul class="flex flex-col gap-2">
                                        <!-- <router-link v-for="cl in chatList" v-bind:key="cl.id" :to="'/' + currentUrl + '/one-to-one-chat/' + cl.id" v-if="chatList.length"> -->
                                       <li class="flex items-center gap-2 justify-between" v-for="cl in chatList" v-bind:key="cl.id" v-if="chatList.length">
                                         <div class="flex items-center gap-2">
                                          <img :src="'https://ui-avatars.com/api/?background=0A0446&color=fff&name='+cl.first_name+' '+cl.last_name" class="rounded-full w-[32px] h-[32px]">
                                        <router-link :to="'/' + currentUrl + '/one-to-one-chat/' + cl.id" v-if="chatList.length">
                                          <span class="text-sm font-medium text-[#101828]">{{ cl.first_name }} {{ cl.last_name }}</span>
                                         </router-link>
                                         </div>
                                         <span class="text-[10px] font-normal text-[#667085]">{{ cl.created_at | fromNow }}</span>
                                       </li>
                                    </ul>
                                 </div>
                                
                              </div>
    </div>
</template>
<script>
export default {
  name: "Chats",
  props: {
    chatList: {},
    currentUrl: String
  }
};
</script>
<style lang=""></style>



// WEBPACK FOOTER //
// src/components/employee/dashboard/sidebar/Chats.vue